var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_186388",
    "data-name": "Group 186388",
    transform: "translate(-1101 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_724933",
    transform: "translate(1105.375 132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182392",
    "data-name": "Group 182392",
    transform: "translate(2.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182391",
    "data-name": "Group 182391",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49753",
    "data-name": "Path 49753",
    d: "M134.087,5.582a.382.382,0,0,0-.348-.224h-1.531V.383A.383.383,0,0,0,131.825,0h-1.531a.383.383,0,0,0-.383.383V5.358h-1.531a.382.382,0,0,0-.288.635l2.679,3.062a.382.382,0,0,0,.576,0l2.679-3.062A.382.382,0,0,0,134.087,5.582Z",
    transform: "translate(-127.998 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182394",
    "data-name": "Group 182394",
    transform: "translate(0 8.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182393",
    "data-name": "Group 182393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49754",
    "data-name": "Path 49754",
    d: "M25.75,352v2.3H17.5V352H16v3.062a.758.758,0,0,0,.75.765H26.5a.757.757,0,0,0,.75-.765V352Z",
    transform: "translate(-16 -352)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149784",
    "data-name": "Rectangle 149784",
    width: 20,
    height: 20,
    transform: "translate(1101 128)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIconWhite);
export default __webpack_public_path__ + "static/media/exportIconWhite.b038f6cb3fa3d24a83e9f3c491f527c5.svg";
export { ForwardRef as ReactComponent };